import { render, staticRenderFns } from "./NhstFreeUserRegistration.vue?vue&type=template&id=3352c05a&scoped=true"
import script from "./NhstFreeUserRegistration.vue?vue&type=script&lang=js"
export * from "./NhstFreeUserRegistration.vue?vue&type=script&lang=js"
import style0 from "./NhstFreeUserRegistration.vue?vue&type=style&index=0&id=3352c05a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352c05a",
  null
  
)

export default component.exports